import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import { isDarkTheme } from '@/constants/Colors';
import Text from '@/components/Typography/Text';
import ToolAvatar from '@/components/Tools/ToolAvatar';
import ToolFavoriteHeart from '@/components/Tools/ToolFavoriteHeart';
import ToolFlagBadges from '@/components/Tools/ToolFlagBadges';
import { getToolPresentation } from '@/components/Tools/toolPresentation';

export default function ToolDetailHeader({ tool, compact }) {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const presentation = getToolPresentation(tool, isDarkTheme(theme));
  return (
    <View style={{ gap: 18, marginBottom: compact ? 24 : 28 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 14 }}>
        <ToolAvatar tool={tool} size={compact ? 44 : 52} iconSize={24} borderRadius={14}
          backgroundColor={presentation.background} color={presentation.foreground} />
        <View style={{ flex: 1, minWidth: 0, gap: 5 }}>
          <Text tag="h1" weight="bold" style={{ fontSize: compact ? 25 : 28, lineHeight: compact ? 31 : 34, letterSpacing: -0.7 }}>{presentation.name}</Text>
          <Text size="s" color="secondary" style={{ lineHeight: 20 }}>{presentation.summary}</Text>
        </View>
        <ToolFavoriteHeart tool={tool} />
      </View>
      {(tool.flags?.isBeta || tool.flags?.isPlusOnly) && <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
        <ToolFlagBadges tool={tool} omit={['featured', 'new']} />
        {tool.flags?.isPlusOnly && <Text size="xs" color="secondary">{t('pages.tools.requiresPlus')}</Text>}
      </View>}
    </View>
  );
}
